var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.inDingTalk)?_c('div',{staticClass:"text-center padding-lg"},[_vm._v("登录中...")]):_c('div',{staticClass:"text-center padding-lg"},[_vm._v("请在钉钉中访问")])])}
var staticRenderFns = []

export { render, staticRenderFns }